export default __webpack_public_path__ + "static/media/avatar_6.f542b969.png";